import React,{Component} from 'react';
import Slider from "react-slick";
import {Link} from 'react-router-dom';
import grid1 from './../../images/gallery/img7.jpeg';
import grid2 from './../../images/gallery/img8.jpeg';
import grid3 from './../../images/gallery/img15.jpeg';


function SampleNextArrow(props) {
  const { onClick } = props;
  return (
  	<div className="owl-nav">
		<div className="owl-next"  onClick={onClick}/>
	</div>	
  );
}

function SamplePrevArrow(props) {
  const { onClick } = props;
  return (
	<div className="owl-nav">
		<div className=" owl-prev " onClick={onClick}/>
	</div>
  );
} 

const latestBlog = [
	{ image: grid1, title: "Parenting Tips from Gurukul Preschool", desc: "Dear Parents, The Gurukul team would like to share our experiences and views on..." },
	{ image: grid2, title: "Kindergarten Is Too Late... Start Today!", desc: "As a parent we must understand that early years are the most critical learning period." },
	{ image: grid3, title: "The Biggest Contribution Of Education Blog To Humanity.", desc: "Separation Tips You and your child are about to have an amazing and fun..." },
	
]
class FromSlider extends Component{	
	render(){
		var settings = {		
			arrows: true,
            slidesToShow: 3,			
            infinite: true,
			autoplay: true,
			nextArrow: <SampleNextArrow />,
			prevArrow: <SamplePrevArrow />,
			responsive: [
				{
				  breakpoint: 1200,
				  settings: {
					slidesToShow: 3,
				  }
				},
				{
				  breakpoint: 991,
				  settings: {
					slidesToShow: 2,
				  }
				},
				{
				  breakpoint: 576,
				  settings: {
					slidesToShow: 1,
				  }
				}
			]
        };
		return(
			<Slider className="blog-carousel owl-carousel owl-theme dots-none sprite-nav owl-btn-center-lr " {...settings}>
				{latestBlog.map((item, index) => (
					<div className="item p-3 wow bounceInUp" data-wow-duration="2s" data-wow-delay="0.2s" key={index}>
						<div className="blog-post blog-grid ">
							<div className="dlab-post-media frame-box">
								<Link to={"./blog"}><img src={item.image} alt="" /></Link>
							</div>
							<div className="dlab-info">
								<div className="dlab-post-title">
									<h4 className="post-title">{item.title}</h4>
								</div>
								<div className="dlab-post-text">
									<p>{item.desc}</p>
								</div>
								{/* <div className="dlab-post-readmore"> 
									<Link to={"./blog-details"} title="READ MORE" rel="bookmark" className="btn-link">Read More</Link>
								</div> */}
							</div>
						</div>
					</div>
				))}	
			</Slider>				
		)
	}
}
export default FromSlider;